var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/line/system/refresh-line",
    clipPath: "url(#clip0_900_2840)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.23521 4.24863C6.97416 2.7418 9.19887 1.91379 11.4998 1.917C16.7927 1.917 21.0832 6.20746 21.0832 11.5003C21.0832 13.5473 20.4411 15.4448 19.3486 17.0012L16.2915 11.5003H19.1665C19.1666 9.99731 18.725 8.5274 17.8964 7.27337C17.0678 6.01935 15.8889 5.03653 14.5063 4.44712C13.1237 3.85771 11.5983 3.68772 10.1198 3.95827C8.64132 4.22882 7.27498 4.92799 6.19067 5.96883L5.23521 4.24863ZM17.7645 18.752C16.0255 20.2589 13.8008 21.0869 11.4998 21.0837C6.20696 21.0837 1.9165 16.7932 1.9165 11.5003C1.9165 9.45333 2.55859 7.55583 3.65109 5.9995L6.70817 11.5003H3.83317C3.83305 13.0034 4.27472 14.4733 5.10328 15.7273C5.93184 16.9813 7.11074 17.9641 8.49337 18.5535C9.87601 19.143 11.4014 19.313 12.8799 19.0424C14.3584 18.7718 15.7247 18.0727 16.809 17.0318L17.7645 18.752Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_2840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.fd026cb4b96021606fde683b28eb1db9.svg";
export { ForwardRef as ReactComponent };